export const DEMO_INBOX = 'hrshgupta84@gmail.com';

export async function sendEnquiry(fields, subject) {
  const response = await fetch(`https://formsubmit.co/ajax/${DEMO_INBOX}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      ...fields,
      _subject: subject,
      _template: 'table',
      _captcha: 'false',
      _replyto: fields.email || DEMO_INBOX,
    }),
  });

  const result = await response.json().catch(() => ({}));
  const failed = !response.ok || result.success === false || result.success === 'false';
  const message = result.message || '';

  if (/activat/i.test(message)) {
    const error = new Error(
      'Please check hrshgupta84@gmail.com and click the FormSubmit activation link, then submit again.'
    );
    error.code = 'activation';
    throw error;
  }

  if (failed) {
    throw new Error(message || 'Unable to send your request. Please try again.');
  }

  return result;
}
